import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as actions from '../../redux/actions/actions-learningobject';
import Button from '../../components/Button';
import SearchBar from '../../components/SearchBar';
import BreadCrumb from '../../components/Breadcrumb';
import Loader from '../../components/Loader';

class LearningObject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ''
    };

    props.getLOBJlist(props.match.params.id);
  }


  deleteLOBJ = (id, LMId) => {
    confirmAlert({
      title: 'Delete learningObject',
      message: 'Are you sure to delete the learningObject?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deleteLOBJ(id, LMId)
              .then(() => {
                toast.success('Deleted Successfully');
              }).catch((error) => {
                toast.error(error.message);
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTableFilter = (search) => {
    this.setState({ searchVal: search });
  }

  setTableOption = () => (this.props.lobjList && this.props.tableLoading ? <Loader /> : 'No Data Found');

  render() {
    const searchVal = this.state.searchVal.toLowerCase();
    const learningObject = this.props.lobjList.filter((item) => item.Name.toLowerCase().includes(searchVal) || item.Type.toLowerCase().includes(searchVal));

    const columns = [{
      dataField: 'Name',
      text: 'Name'
    }, {
      dataField: 'Type',
      text: 'Type'
    }, {
      dataField: 'Description',
      text: 'Description'
    }, {
      dataField: 'CreatedDateTime',
      text: 'Created at',
      formatter: (cell, row) => (
        new Date(cell).toLocaleDateString()
      ),
      sort: true
    }, {
      dataField: 'Id',
      text: 'Actions',
      headerStyle: {
        width: '140px'
      },
      formatter: (cell, row) => (
        <>
          <span
            role="presentation"
            className="fa fa-pencil-alt tableEdit"
            onClick={() => this.props.history.push({
              pathname: `/courses/learning-object-editor/${cell}`,
              state: {
                LearningModuleId: this.props.match.params.id
              }
            })}
          />
          <span
            role="presentation"
            className="fa fa-trash tableDelete"
            onClick={() => this.deleteLOBJ(cell, this.props.match.params.id)}
          />
        </>
      )
    }];

    const defaultSorted = [{
      dataField: 'CreatedDateTime',
      order: 'desc'
    }];

    return (
      <div>
        <div className="container">
          <BreadCrumb currentPage="Learning Object" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-8">
                    {/* <span className="fa fa-cogs cardTitle"> Learning Object</span> */}
                    <SearchBar
                      placeholder="Search by Name , Type"
                      handleChange={(e) => this.handleTableFilter(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 text-right">
                    <Button
                      className="btn btn-sm btn-secondary ml-1 float-right"
                      onClick={() => this.props.history.push({
                        pathname: '/courses/learning-object-editor/0',
                        state: {
                          LearningModuleId: this.props.match.params.id
                        }
                      })}
                    >
                      <span className="fas fa-plus" />
                      {' '}
                      Add New
                    </Button>
                    <Button
                      className="btn btn-sm btn-secondary ml-1 float-right"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fas fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">

                <BootstrapTable
                  keyField="Id"
                  data={learningObject}
                  columns={columns}
                  pagination={paginationFactory()}
                  defaultSorted={defaultSorted}
                  noDataIndication={() => this.setTableOption()}
                  hover
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LearningObject.defaultProps = {
  tableLoading: false,
  lobjList: null,
  getLOBJlist: null,
  deleteLOBJ: null
};

LearningObject.propTypes = {
  tableLoading: PropTypes.bool,
  lobjList: PropTypes.array,
  getLOBJlist: PropTypes.func,
  deleteLOBJ: PropTypes.func
};

const mapStateToProps = ({ learningObject }) => ({
  tableLoading: learningObject.tableLoading,
  lobjList: learningObject.lobjList
});

const mapDispatchToProps = (dispatch) => ({

  getLOBJlist: (LMId) => dispatch(actions.fetchLOBJ(LMId)),
  deleteLOBJ: (id, LMId) => dispatch(actions.deleteLOBJ(id, LMId))

});

export default connect(mapStateToProps, mapDispatchToProps)(LearningObject);
